import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import AdvancedFiltersDialog from "./AdvancedFiltersDialog";
import { displayMultiSelect } from "../Utility/ChipDisplay";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IAdvancedFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function AdvancedFilters({ callTableViewModel, setCallTableViewModel }: IAdvancedFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'Advanced'
            }
            {
                callTableViewModel.filters.advancedFilters.randomSelection > 0 ? ` - Random Selected is : ${callTableViewModel.filters.advancedFilters.randomSelection}` : ''
            }
            {
                callTableViewModel.filters.advancedFilters.randomAgentSelection > 0 ? ` - Random Agent Selected is : ${callTableViewModel.filters.advancedFilters.randomAgentSelection}` : ''
            }
            {
                displayMultiSelect(callTableViewModel.filters.advancedFilters.tags, 'Tags')
            }
            {
                callTableViewModel.filters.advancedFilters.isUnflaggedNC === true ? ` - Unflagged NC` : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <AdvancedFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel} />
        </>
    )
}